import { FC, useEffect, useRef, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import Header from "../layouts/header";
import Footer from "../layouts/footer";
import { usePermissions } from "../../context/PermissionsContext";
import { AppDispatch } from "../../redux/store";
import { useDispatch } from "react-redux";
import { getPoketProfileById } from "../../redux/actions/poketProfileAction";
import { Poketprofile } from "../../Typings/dataListing";
const PocketProfileView: FC = () => {
  const roleid = localStorage.getItem("roleid") ?? "";
  const { permissions, loading, error } = usePermissions();
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams();
  const navigate = useNavigate();
  const [poketProfileData, setpoketProfileData] = useState<Poketprofile | null>(
    null
  );
  const { FarmId } = useParams();

  useEffect(() => {
    getpoketProfileData();
  }, [dispatch]);

  const getpoketProfileData = async () => {
    const payload = { id: id };
    try {
      dispatch(
        getPoketProfileById(payload, (response: any) => {
          const farmData = response?.data;
          if (farmData) {
            setpoketProfileData(farmData);
          }
        })
      );
    } catch (error) {
      console.error("Error fetching farm details:", error);
    }
  };

  return (
    <div>
      <Header />
      <div className="midCon pb-2">
        <section className="pt-4 pb-4 pt-md-5 pb-md-5">
          <div className="container">
            <div className="loginHd mb-1">
              <span className="d-block">Poket Profile</span>
              {poketProfileData?.id || "-"}
            </div>
          </div>
        </section>
        <section className="pt-4 pb-4 pt-md-5 pb-md-5 mt-2 whtBg">
          <div className="container">
            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                ID{" "}
                <span className="d-block pt-1">
                  {poketProfileData?.id || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Poket User ID{" "}
                <span className="d-block pt-1">
                  {poketProfileData?.poket_user_id || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                State{" "}
                <span className="d-block pt-1">
                  {poketProfileData?.state || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                County{" "}
                <span className="d-block pt-1">
                  {poketProfileData?.county || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Latitude{" "}
                <span className="d-block pt-1">
                  {poketProfileData?.latitude || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Longitude{" "}
                <span className="d-block pt-1">
                  {poketProfileData?.longitude || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Timestamp{" "}
                <span className="d-block pt-1">
                  {poketProfileData?.timestamp || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Underserved Status{" "}
                <span className="d-block pt-1">
                  {poketProfileData?.underserved_status || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Type of Operation Rolled{" "}
                <span className="d-block pt-1">
                  {poketProfileData?.type_of_operation_rolled || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Type of Operation Rolled 2{" "}
                <span className="d-block pt-1">
                  {poketProfileData?.type_of_operation_rolled2 || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Task End Timestamp{" "}
                <span className="d-block pt-1">
                  {poketProfileData?.timestamp || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Farm Name{" "}
                <span className="d-block pt-1">
                  {poketProfileData?.farm_name || "-"}
                </span>
              </li>

              <li className="col-6 col-md-4 col-lg-3">
                Contact Method{" "}
                <span className="d-block pt-1">
                  {poketProfileData?.contact_method || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Contact Method 2{" "}
                <span className="d-block pt-1">
                  {poketProfileData?.contact_method2 || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Farm Photo 0{" "}
                <span className="d-block pt-1">
                  {poketProfileData?.farm_photo_0 || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Survey Version{" "}
                <span className="d-block pt-1">
                  {poketProfileData?.survey_version || "-"}
                </span>
              </li>
              <li className="col-12 col-md-12 col-lg-12">
                Why Excited{" "}
                <span className="d-block pt-1">
                  {poketProfileData?.why_excited || "-"}
                </span>
              </li>
            </ul>
            <div className="pt-5 text-end">
              <NavLink to="/PoketProfile">
                <button type="button" className="formBtn cancel">
                  Cancel
                </button>
              </NavLink>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default PocketProfileView;
